import React from "react";
import Modal from "react-modal";
import styled from "styled-components";
import "../../styles/CustomModal.css";

const LoadingModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  cancel_description: string;
}) => {
  const onCloseModal = () => {};

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="loadingModal modal-content"
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/gif/loadingImage.gif`}
            alt="로딩이미지"
          />
        </div>
      </Style>
    </Modal>
  );
};

export default LoadingModal;

const Style = styled.div`
  .modal {
    width: 100vw;
    height: 100dvh;
    background: #000000;
  }
  img {
    width: 100%;
    height: 100%;
  }
`;
